var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengeYour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 121,
    viewBox: "0 0 122 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_13344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7567 32.8266L26.6966 81.5111L24.3154 81.2142L30.2684 32.2329L31.7567 32.8266Z",
    fill: "#1EE2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3516 30.7489L3.87733 21.7793L6.54903 31.7987L0 39.4559L29.866 49.6367L32.3516 30.7489Z",
    fill: "#1EE2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.4554L6.54903 31.7982L3.87733 21.7788L32.3516 30.7484L6.42755 24.6467L7.7634 32.9264L0 39.4554Z",
    fill: "#9CFFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5198 49.698L46.534 60.7745L49.614 59.853L48.074 48.1802L41.5198 49.698Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2816 49.4088L78.0949 60.7744L75.0149 59.8529L76.8036 46.1377L83.2816 49.4088Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2238 114.056C39.2238 114.056 28.1129 114.391 32.4899 119.093C36.8669 123.794 54.0386 116.742 54.0386 116.742L39.2238 114.056Z",
    fill: "url(#paint0_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7177 114.056C89.7177 114.056 100.829 114.392 96.4516 119.093C92.0745 123.794 74.9031 116.743 74.9031 116.743L89.7177 114.056Z",
    fill: "url(#paint1_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9074 77.2627L37.0327 76.0283C35.1001 74.9435 33.0131 74.1587 30.8434 73.701C29.1324 73.3406 27.2794 73.2023 25.6964 73.9434C23.4238 75.0074 22.2759 77.6497 22.1347 80.1494C22.0724 81.2546 22.1744 82.3945 22.6481 83.3955C23.6619 85.5377 26.0803 86.5704 28.2964 87.4224L33.8792 89.5687C34.0929 89.6509 34.3282 89.734 34.5456 89.6617C34.6795 89.6079 34.7977 89.5212 34.8893 89.4099C35.5722 88.674 35.8512 87.6625 36.1078 86.693L37.3029 82.1793L37.1189 78.9313C37.1182 79.0076 37.9074 77.186 37.9074 77.2627Z",
    fill: "url(#paint2_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0518 77.5835L90.9265 76.3492C92.8591 75.2643 94.9462 74.4795 97.1159 74.0218C98.8267 73.6613 100.68 73.5231 102.263 74.2643C104.535 75.3282 105.683 77.9705 105.824 80.4703C105.887 81.5755 105.785 82.7154 105.311 83.7164C104.297 85.8584 101.879 86.8913 99.6629 87.7433L94.0801 89.8896C93.8664 89.9718 93.631 90.0549 93.4137 89.9826C93.2798 89.9286 93.1617 89.842 93.07 89.7307C92.3871 88.9948 92.1081 87.9834 91.8514 87.0139C91.4533 85.5092 91.0549 84.0046 90.6564 82.5001L90.8403 79.2521C90.841 79.3284 90.0518 77.5073 90.0518 77.5835Z",
    fill: "url(#paint3_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.153 72.8862C100.822 71.8252 99.4938 71.1089 98.7231 69.4986C97.9776 67.9415 98.2056 66.0299 98.5089 64.3971C99.0678 61.3846 100.412 58.7066 99.996 55.567C99.9916 55.5391 99.9765 55.514 99.9538 55.4971C99.9311 55.4801 99.9027 55.4728 99.8747 55.4765C99.8466 55.4803 99.8211 55.4949 99.8037 55.5172C99.7863 55.5395 99.7784 55.5677 99.7816 55.5957C100.229 60.3006 95.1081 67.398 99.5199 71.4421C100.599 72.4309 101.902 73.1275 102.903 74.2037C104.399 75.8107 103.916 78.2724 103.312 80.1344C102.46 82.76 100.627 85.2532 101.405 88.1184C101.41 88.15 101.428 88.1782 101.454 88.1971C101.48 88.216 101.512 88.2241 101.544 88.2198C101.576 88.2156 101.605 88.1992 101.625 88.1742C101.645 88.1491 101.655 88.1173 101.652 88.0854C101.609 83.0612 107.31 76.9988 102.153 72.8862Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5044 53.9357L94.5027 57.5041L104.128 57.173L101.423 52.9585L96.5044 53.9357Z",
    fill: "url(#paint4_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8341 54.4961C112.076 53.3947 120.951 40.9076 119.657 26.6054C118.364 12.3032 107.391 1.60194 95.1491 2.70339C82.9073 3.80485 74.0322 16.292 75.3259 30.5941C76.6196 44.8963 87.5923 55.5976 99.8341 54.4961Z",
    fill: "url(#paint5_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.834 54.4959C112.076 53.3943 120.95 40.9073 119.657 26.605C118.492 13.7314 109.485 3.78033 98.7694 2.72314C101.041 4.23051 102.961 6.20898 104.396 8.52354C107.077 12.8274 108.15 17.9631 108.369 23.0253C108.457 25.0727 108.413 27.1376 108.018 29.1486C106.967 34.4967 103.361 39.2317 98.6055 41.9173C93.85 44.6029 88.0451 45.2679 82.731 43.9983C81.731 43.7595 80.6445 43.4687 79.6541 43.578C84.209 50.7936 91.743 55.2239 99.834 54.4959Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0218 50.1425C105.879 49.5255 111.19 46.293 110.886 42.9224C110.581 39.5519 104.775 37.3196 97.9177 37.9366C91.0607 38.5536 85.7491 41.7861 86.054 45.1566C86.3589 48.5272 92.1648 50.7594 99.0218 50.1425Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1492 2.70307C82.9075 3.80449 74.0328 16.2917 75.3264 30.5938C76.1527 39.7281 80.93 47.3873 87.4616 51.4474C87.1619 51.0029 86.8796 50.5511 86.618 50.0958C82.504 42.9398 81.2557 34.3619 82.1951 26.1663C82.5556 23.0208 83.2401 19.8675 84.7132 17.0631C85.7796 15.033 87.2359 13.2305 88.8013 11.5528C92.0934 8.02501 95.9725 4.96367 100.343 2.946C98.6306 2.63065 96.8834 2.54893 95.1492 2.70307Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.422 15.5323C89.5131 13.7199 88.1138 12.1769 86.2965 12.086C84.4793 11.9951 82.9322 13.3907 82.841 15.2032C82.7499 17.0156 84.1492 18.5585 85.9665 18.6494C87.7838 18.7403 89.3308 17.3448 89.422 15.5323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.883 39.7596C109.577 39.5102 109.937 38.7469 109.687 38.0548C109.437 37.3627 108.671 37.0039 107.977 37.2534C107.283 37.5028 106.924 38.2661 107.174 38.9582C107.424 39.6503 108.189 40.0091 108.883 39.7596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7071 84.8796C97.5177 92.5345 102.203 104.725 95.5741 111.966C88.564 119.625 73.2561 118.7 64.0966 118.7C54.9371 118.7 39.6292 119.625 32.6191 111.966C25.9901 104.725 30.6756 92.5346 33.4861 84.8795C37.874 72.928 47.3739 45.3651 64.0966 45.3647C80.8193 45.3644 90.3193 72.9285 94.7071 84.8796Z",
    fill: "url(#paint6_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1305 66.3654C81.8249 55.6412 74.3071 45.3646 64.0964 45.3647C47.3736 45.3647 37.8737 72.928 33.4859 84.8795C31.0481 91.5192 27.205 101.569 30.5526 108.844C30.1894 106.24 30.2462 103.596 30.7208 101.01C32.3663 92.1887 44.5023 48.0821 62.1921 47.0563C71.6819 46.5061 80.7559 56.7007 87.1305 66.3654Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7119 51.9826C48.5065 51.9826 53.204 47.416 53.204 41.7828C53.204 36.1496 48.5065 31.583 42.7119 31.583C36.9172 31.583 32.2197 36.1496 32.2197 41.7828C32.2197 47.416 36.9172 51.9826 42.7119 51.9826Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7119 50.9419C48.5065 50.9419 53.204 46.6083 53.204 41.2624C53.204 35.9166 48.5065 31.583 42.7119 31.583C36.9172 31.583 32.2197 35.9166 32.2197 41.2624C32.2197 46.6083 36.9172 50.9419 42.7119 50.9419Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1873 48.6747C47.6922 48.6747 52.1549 44.8486 52.1549 40.1288C52.1549 35.4091 47.6922 31.583 42.1873 31.583C36.6824 31.583 32.2197 35.4091 32.2197 40.1288C32.2197 44.8486 36.6824 48.6747 42.1873 48.6747Z",
    fill: "url(#paint7_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.1877 48.6749C47.6926 48.6749 52.1553 44.8488 52.1553 40.1291C52.1542 39.0875 51.9348 38.0576 51.5112 37.1055C51.1786 37.7586 50.7533 38.3606 50.2484 38.8926C48.7652 40.4514 46.7453 41.4014 44.6869 42.0367C42.0258 42.8582 39.157 43.2057 36.4449 42.571C34.9029 42.2152 33.4622 41.5146 32.2314 40.5223C32.4714 45.0594 36.8365 48.6749 42.1877 48.6749Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4663 45.2393C44.4944 45.2393 46.1386 43.6777 46.1386 41.7513C46.1386 39.8248 44.4944 38.2632 42.4663 38.2632C40.4381 38.2632 38.7939 39.8248 38.7939 41.7513C38.7939 43.6777 40.4381 45.2393 42.4663 45.2393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1165 44.3674C43.9515 44.3674 45.4391 43.001 45.4391 41.3153C45.4391 39.6297 43.9515 38.2632 42.1165 38.2632C40.2815 38.2632 38.7939 39.6297 38.7939 41.3153C38.7939 43.001 40.2815 44.3674 42.1165 44.3674Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.357 39.947C41.9033 39.4021 41.9033 38.5188 41.357 37.9739C40.8107 37.429 39.9249 37.429 39.3786 37.9739C38.8323 38.5188 38.8323 39.4021 39.3786 39.947C39.9249 40.4919 40.8107 40.4919 41.357 39.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5429 37.0477C48.7904 35.5265 47.7546 34.0932 46.2293 33.8464C44.704 33.5995 43.2669 34.6326 43.0194 36.1538C42.7719 37.675 43.8078 39.1083 45.333 39.3552C46.8583 39.602 48.2954 38.5689 48.5429 37.0477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6006 51.3679C90.3952 51.3679 95.0927 46.8013 95.0927 41.1681C95.0927 35.5349 90.3952 30.9683 84.6006 30.9683C78.8059 30.9683 74.1084 35.5349 74.1084 41.1681C74.1084 46.8013 78.8059 51.3679 84.6006 51.3679Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6006 50.3271C90.3952 50.3271 95.0927 45.9935 95.0927 40.6477C95.0927 35.3019 90.3952 30.9683 84.6006 30.9683C78.8059 30.9683 74.1084 35.3019 74.1084 40.6477C74.1084 45.9935 78.8059 50.3271 84.6006 50.3271Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.076 48.0599C89.5809 48.0599 94.0436 44.2338 94.0436 39.5141C94.0436 34.7944 89.5809 30.9683 84.076 30.9683C78.571 30.9683 74.1084 34.7944 74.1084 39.5141C74.1084 44.2338 78.571 48.0599 84.076 48.0599Z",
    fill: "url(#paint8_radial_2_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.0762 48.0597C89.5813 48.0597 94.0438 44.2336 94.0438 39.5139C94.0428 38.4722 93.8234 37.4423 93.3998 36.4902C93.0672 37.1434 92.6419 37.7453 92.137 38.2774C90.6538 39.8362 88.6339 40.7862 86.5756 41.4214C83.9145 42.243 81.0456 42.5904 78.3335 41.9558C76.7916 41.5999 75.3509 40.8994 74.1201 39.9071C74.3601 44.4441 78.7252 48.0597 84.0762 48.0597Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3549 44.6241C86.3831 44.6241 88.0273 43.0624 88.0273 41.136C88.0273 39.2096 86.3831 37.6479 84.3549 37.6479C82.3268 37.6479 80.6826 39.2096 80.6826 41.136C80.6826 43.0624 82.3268 44.6241 84.3549 44.6241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0052 43.7522C85.8402 43.7522 87.3278 42.3857 87.3278 40.7001C87.3278 39.0144 85.8402 37.6479 84.0052 37.6479C82.1702 37.6479 80.6826 39.0144 80.6826 40.7001C80.6826 42.3857 82.1702 43.7522 84.0052 43.7522Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2566 39.7411C83.0292 39.7411 83.6555 39.1164 83.6555 38.3459C83.6555 37.5753 83.0292 36.9507 82.2566 36.9507C81.484 36.9507 80.8577 37.5753 80.8577 38.3459C80.8577 39.1164 81.484 39.7411 82.2566 39.7411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3926 36.627C90.7476 35.1272 89.8163 33.6242 88.3124 33.2702C86.8085 32.9161 85.3016 33.8449 84.9465 35.3448C84.5915 36.8447 85.5228 38.3476 87.0267 38.7017C88.5306 39.0558 90.0375 38.1269 90.3926 36.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4404 86.6372C47.4404 86.6372 62.2954 97.4122 80.3017 86.6372C80.3017 86.6372 59.5946 92.0246 47.4404 86.6372Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1992 88.7392C51.1992 88.7392 50.9308 81.9113 52.1389 81.3759C53.347 80.8404 58.8507 82.4469 58.8507 82.4469L56.6985 90.531L51.1992 88.7392Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4273 88.6188C76.4273 88.6188 76.6983 81.7299 75.4901 81.1943C74.2819 80.6587 68.7783 82.2653 68.7783 82.2653L71.0604 90.5658L76.4273 88.6188Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.9579 115.446C42.7833 115.588 43.6126 115.713 44.4465 115.81C52.2175 116.708 60.4523 115.528 68.1001 114.076C75.2076 112.726 82.4014 110.822 88.9552 107.709C92.4596 106.045 96.1054 103.98 98.9276 101.275C98.688 95.5322 96.3705 89.4118 94.7066 84.8797C94.4777 84.2564 94.2331 83.586 93.9761 82.8838C88.0177 92.5439 77.1061 99.3834 66.705 103.278C59.046 106.146 50.8265 107.815 42.623 107.433C38.699 107.231 34.8134 106.56 31.0493 105.436C30.5279 105.282 29.9824 105.116 29.4258 104.934C29.6888 106.754 30.2467 108.485 31.1965 110.056C31.1965 110.056 35.303 113.302 41.9579 115.446Z",
    fill: "#FF3300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-216.2 119.764) scale(23.3556 23.259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-444.546 119.764) rotate(180) scale(23.3555 23.259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5812 72.757) scale(17.7464 17.6976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-761.65 73.0778) rotate(180) scale(17.7465 17.6977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-121.926 61.3406) scale(7.75647 7.72756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6871 30.4062) rotate(-0.743049) scale(24.2261 24.2087)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.6934 70.4573) scale(50.234 50.1117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2265 32.6256) scale(21.3789 21.3133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.0988 32.0109) scale(21.3789 21.3133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_13344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 120,
    fill: "white",
    transform: "translate(0 0.708984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeYour);
export default __webpack_public_path__ + "static/media/challengeYour.dcd6c44971f6f7f1db7ab7f144ce12b1.svg";
export { ForwardRef as ReactComponent };